module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp12_7016.d8041ab5.png";